import axiosInstance from './httpInterceptor';
import axiosIAInstance from './aiHttpInterceptor';
import axiosPublicInstance from './publicHttpInterceptor';
import axiosPublicIAInstance from './publicAIHttpInterceptor';
import axiosChatInstance from './chatHttpInterceptor';

export const globalGetService = (url, params) => {
  return new Promise(function (resolve, reject) {
    axiosInstance({
      method: 'GET',
      url: url,
      params: params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const globalPostService = (url, data) => {
  return new Promise(function (resolve, reject) {
    axiosInstance({
      method: 'POST',
      url: url,
      data: data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const globalPutService = (url, data) => {
  return new Promise(function (resolve, reject) {
    axiosInstance({
      method: 'PUT',
      url: url,
      data: data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const globalExportService = (url, queryParams = {}) => {
  return new Promise(function (resolve, reject) {
    axiosInstance({
      method: 'GET',
      url: url,
      responseType: 'blob',
      params: queryParams,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        console.err(err, 'error');
        reject(err);
      });
  });
};
export const globalDeleteService = (url, data) => {
  return new Promise(function (resolve, reject) {
    axiosInstance({
      method: 'DELETE',
      url: url,
      data: data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const API = (function () {
  const success = (res) => res?.statusCode >= 200 && res?.statusCode < 300;

  const post = async (url, body, config) => {
    const response = await axiosInstance.post(url, body, config);
    if (success(response)) return response;
    throw new Error(response.message);
  };
  const del = async (url, body, config) => {
    const response = await axiosInstance.delete(url, body, config);
    if (success(response)) return response;
    throw new Error(response.message);
  };
  const put = async (url, body, config) => {
    const response = await axiosInstance.put(url, body, config);
    if (success(response)) return response;
    throw new Error(response.message);
  };
  const get = async (url, config) => {
    const response = await axiosInstance.get(url, config);
    if (success(response)) return response;
    throw new Error(response.message);
  };

  const getTemporary = async (url, config) => {
    const response = await axiosInstance.get(url, config);
    if (response) return response;
    throw new Error(response.error);
  };

  return { post, get, put, del, getTemporary };
})();

export const AI_API = (function () {
  const post = async (url, body, config) => {
    const response = await axiosIAInstance.post(url, body, config);
    if (response) return response;
    throw new Error(response.error || response?.data?.error);
  };

  const get = async (url, config) => {
    const response = await axiosIAInstance.get(url, config);
    if (response) return response;
    throw new Error(response.error);
  };

  const put = async (url, body, config) => {
    const response = await axiosIAInstance.put(url, body, config);
    if (response) return response;
    throw new Error(response.message);
  };

  return { post, get, put };
})();

/**Function that encapsulates a fetch configured to handle streams (makes the HTTP request) */
export async function fetchEventStream({ body, org_id }) {
  const url = `${process.env.REACT_APP_BASE_AI_URL}/orgs/${org_id}/chat/`;
  const token = JSON.parse(localStorage.getItem('userInfo'))['access'];

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok || !response.body) {
    throw new Error(`Error: ${response.statusText}`);
  }

  return response;
}

export const PUBLIC_API = (function () {
  const post = async (url, body, config) => {
    const response = await axiosPublicInstance.post(url, body, config);
    if (response) return response;
    throw new Error(response.error || response?.data?.error);
  };

  const get = async (url, config) => {
    const response = await axiosPublicInstance.get(url, config);
    if (response) return response;
    throw new Error(response.error);
  };

  const put = async (url, body, config) => {
    const response = await axiosPublicInstance.put(url, body, config);
    if (response) return response;
    throw new Error(response.message);
  };

  return { post, get, put };
})();

export const PUBLIC_AI_API = (function () {
  const post = async (url, body, config) => {
    const response = await axiosPublicIAInstance.post(url, body, config);
    if (response) return response;
    throw new Error(response.error || response?.data?.error);
  };

  const get = async (url, config) => {
    const response = await axiosPublicIAInstance.get(url, config);
    if (response) return response;
    throw new Error(response.error);
  };

  const put = async (url, body, config) => {
    const response = await axiosPublicIAInstance.put(url, body, config);
    if (response) return response;
    throw new Error(response.message);
  };

  return { post, get, put };
})();

export const CHAT_API = (function () {
  const success = (res) => res?.status >= 200 && res?.status < 300;

  const post = async (url, body, config) => {
    const response = await axiosChatInstance.post(url, body, config);
    if (success(response)) return response.data;
    throw new Error(response?.data?.message);
  };

  const put = async (url, body, config) => {
    const response = await axiosChatInstance.put(url, body, config);
    if (success(response)) return response.data;
    throw new Error(response?.data?.message);
  };

  const get = async (url, config) => {
    try {
      const response = await axiosChatInstance.get(url, {
        ...config,
        showError: false,
      });
      return response.data;
    } catch (error) {
      return error?.response?.data?.message;
    }
  };

  const patch = async (url, body, config) => {
    try {
      const response = await axiosChatInstance.patch(url, body, {
        ...config,
        showError: false,
      });
      return response.data;
    } catch (error) {
      return error?.response?.data?.message;
    }
  };


  return { post, put, get, patch };
})();

export async function newFetchEventStream({ firstMessage, body, conversation_id }) {
  const initialURL = process.env.REACT_APP_BASE_CHAT_INTEGRATION;
  const url = firstMessage
    ? `${initialURL}conversations`
    : `${initialURL}conversations/${conversation_id}`;
  const key = JSON.parse(localStorage.getItem('userInfo'))['chat_api_key'];

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': key,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok || !response.body) {
    //Improve handle errors
    throw new Error(`Error: ${response.statusText}`);
  }

  return response;
}

export async function newReFetchEventStream({ body, conversation_id, message_id }) {
  const initialURL = process.env.REACT_APP_BASE_CHAT_INTEGRATION;
  const url = `${initialURL}conversations/${conversation_id}/messages/${message_id}/regenerate`;
  const key = JSON.parse(localStorage.getItem('userInfo'))['chat_api_key'];

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': key,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok || !response.body) {
    //Improve handle errors
    throw new Error(`Error: ${response.statusText}`);
  }

  return response;
}
